import { motion } from "framer-motion";
import { AlertCircle } from "lucide-react";

const AmberCallout = ({ children, id }) => (
  <div
    data-testid={`amber-placeholder-callout-${id}`}
    className="bg-amber-50/80 border border-amber-400 text-amber-800 rounded-lg p-4 font-sans text-sm flex items-start gap-3 shadow-sm"
  >
    <AlertCircle className="w-4 h-4 mt-0.5 shrink-0 text-amber-600" aria-hidden="true" />
    <div>
      <span className="inline-block text-[10px] font-mono uppercase tracking-wider bg-amber-100 text-amber-700 rounded px-1.5 py-0.5 mb-1.5">
        Placeholder
      </span>
      <p className="leading-relaxed">{children}</p>
    </div>
  </div>
);

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="text-xs font-mono uppercase tracking-[0.2em] text-terra mb-4">{children}</p>
);

export default AmberCallout;
